"use client";
import { checkDevice, useDeviceType, useIsMobile } from "@/store/device";
import { FC, useEffect } from "react";

export const DeviceType: FC = () => {
  const isDev = process.env.NODE_ENV === "development";

  const checkDeviceType = checkDevice();
  const deviceType = useDeviceType();
  const mobile = useIsMobile();

  useEffect(() => {
    checkDeviceType();
  }, [checkDeviceType]);

  if (!isDev) return null;

  return (
    <span className="fixed z-10 text-lime-300 text-right p-[20px] bottom-[20px] left-[20px] text-[14px]">
      Device - {deviceType} <br />
      is mobile - {String(mobile)}
    </span>
  );
};
